import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { fetchBalance } from './api';
import { fmtSum, fmtResid } from './format';

export default function BalanceScreen({ budget, period, periodId, budgets, refreshKey }) {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || '').toLowerCase().startsWith('kk') ? 'kk' : 'ru';
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    setData(null);
    if (!periodId) return undefined;
    fetchBalance(budget, periodId).then((d) => {
      if (alive) setData(d);
    });
    return () => {
      alive = false;
    };
  }, [budget, periodId, refreshKey]);

  const b = budgets.find((x) => x.k === budget) || {};
  const who =
    `${lang === 'kk' ? b.kk : b.ru || ''} · ${t('budgetEntering.onDate')} ${period}` +
    (data && data.is_partial ? ` · ${t('budgetEntering.partial')}` : '');

  const kpis = data
    ? [
        {
          c: t('budgetEntering.kRes'),
          v: fmtSum(data.kpi.resources),
        },
        { c: t('budgetEntering.kUse'), v: fmtSum(data.kpi.uses) },
        {
          c: t('budgetEntering.kResid'),
          v: fmtResid(data.kpi.residual),
        },
        {
          c: data.kpi.is_surplus ? t('budgetEntering.kSur') : t('budgetEntering.kDef'),
          v: fmtSum(Math.abs(data.kpi.deficit)),
        },
      ]
    : [];

  return (
    <section>
      <div className="bp-note warn">{t('budgetEntering.balNote')}</div>
      <div className="bp-card">
        <div className="bp-card-h">
          <h2>{t('budgetEntering.balTitle')}</h2>
          <span className="bp-who">{who}</span>
        </div>
        <div className="bp-card-b">
          <div className="bp-kpis">
            {kpis.map((k) => (
              <div className="bp-kpi" key={k.c}>
                <div className="c">{k.c}</div>
                <div className="v">{k.v}</div>
                <div className="h">{k.h}</div>
              </div>
            ))}
          </div>

          <div className="bp-sectitle" style={{ marginTop: 20 }}>
            {t('budgetEntering.balChecks')}
          </div>
          <div>
            {data &&
              data.checks.map((c) => (
                <div className={`bp-chk ${c.ok ? 'ok' : 'no'}`} key={c.id}>
                  <span className="ic">{c.ok ? '✓' : '✗'}</span>
                  <span>
                    {t(`budgetEntering.${c.key}`, c.formula)}{' '}
                    <span className="fmla">{c.formula}</span>
                  </span>
                  <span className="res">
                    {t('budgetEntering.resid')}: {fmtResid(c.residual)}
                  </span>
                </div>
              ))}
          </div>

          {data && data.carryover && (
            <div className={`bp-chk ${data.carryover.ok ? 'ok' : 'no'}`} style={{ marginTop: 8 }}>
              <span className="ic">{data.carryover.ok ? '✓' : '✗'}</span>
              <span>{t('budgetEntering.balCarry')}</span>
              <span className="res">
                {t('budgetEntering.resid')}: {fmtResid(data.carryover.residual)}
              </span>
            </div>
          )}

          {data && data.missing_sections && data.missing_sections.length > 0 && (
            <div className="bp-hint" style={{ marginTop: 12 }}>
              {t('budgetEntering.balMissing', { s: data.missing_sections.join(', ') })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
